import { CoverProviderContext } from "./CoverProviderContext.js";
import { useSafeScrollTop } from "../../hooks/layout/use-safe-scroll-top.js";
import { FullBleed } from "../full-bleed/FullBleed.js";
import cover_module_default from "./cover.module.js";
import { Overlay, Portal } from "@mantine/core";
import { useContext } from "react";
import { jsx } from "react/jsx-runtime";

//#region src/components/cover/Cover.tsx
const Cover = ({ fullScreen = false, children, visible = false, allowScroll = false, bodySpacing, "data-testid": testId }) => {
	const { coverPageTarget } = useContext(CoverProviderContext);
	useSafeScrollTop(visible);
	const props = fullScreen ? {
		center: true,
		fixed: true
	} : {
		display: "flex",
		p: "inherit"
	};
	const overflowClass = allowScroll ? "" : cover_module_default["root--no-overflow"];
	if (!visible) return null;
	return /* @__PURE__ */ jsx(Portal, {
		target: coverPageTarget?.current ?? void 0,
		children: /* @__PURE__ */ jsx(Overlay, {
			classNames: { root: `${cover_module_default.root} ${overflowClass}` },
			...props,
			"data-testid": testId,
			children: /* @__PURE__ */ jsx(FullBleed, {
				color: "body",
				flex: true,
				spacing: bodySpacing,
				children
			})
		})
	});
};

//#endregion
export { Cover };